import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import logger from "redux-logger";
import { combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";

import { reducers } from "main/reducers";

const rootReducer = combineReducers({
  ...reducers,
});

const createStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      process.env.NODE_ENV === "production"
        ? getDefaultMiddleware()
        : getDefaultMiddleware().concat(logger as Middleware),
  });
};

export const store = createStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppStore = ReturnType<typeof createStore>;
export const wrapper = createWrapper<AppStore>(createStore);
